import React from 'react';

interface ErrorBannerProps {
  message: string;
  details?: string[];
  onClose: () => void;
}

export function ErrorBanner({ message, details, onClose }: ErrorBannerProps) {
  if (!message) {return null;}
  return (
    <div className="mb-4 border border-red-300 bg-red-50 text-red-800 rounded p-3">
      <div className="flex items-start justify-between">
        <div className="mr-4">
          <p className="font-semibold">{message}</p>
          {details && details.length > 0 && (
            <ul className="mt-2 list-disc list-inside text-sm">
              {details.map((d, idx) => (
                <li key={idx}>{d}</li>
              ))}
            </ul>
          )}
        </div>
        <button
          aria-label="Dismiss error"
          className="ml-4 px-2 py-1 text-sm rounded border border-red-300 hover:bg-red-100"
          onClick={onClose}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

export default ErrorBanner;